import { styled, Typography } from '@mui/material';

export const Title = styled(Typography)`
  text-align: center;
  margin-bottom: 16px;
  font-size: 30px;
  line-height: 34px;
  font-weight: 700;
  margin-bottom: 40px;

  ${({ theme }) => theme.breakpoints.up('md')} {
    margin-bottom: 24px;
    font-size: 36px;
    line-height: 43px;
  }
`;
